module.exports = {
	addNewCustomer(state, payload) {
		state.customers.push(payload)
	}
};
